/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Bio_Intro_SuffixInputs */

const en_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` years building real products, not just side projects.`)
};

const ar_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` سنوات خبرة في بناء منتجات حقيقية، لا مجرد مشاريع جانبية.`)
};

const bn_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` বছরের অভিজ্ঞতা সাইড প্রজেক্টে নয়, বাস্তব পণ্য তৈরিতে।`)
};

const de_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahre Entwicklung echter Produkte, nicht nur Nebenprojekte.`)
};

const es_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`años creando productos reales, no solo proyectos paralelos.`)
};

const fr_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ans à créer de vrais produits, pas seulement des projets parallèles.`)
};

const pt_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anos construindo produtos reais, não apenas projetos paralelos.`)
};

const zh_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年构建真正的产品，而不仅仅是副项目。`)
};

const tr_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yıldır yan projeler değil, gerçek ürünler üretiyorum.`)
};

const ru_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`лет создания реальных продуктов, а не просто побочных проектов.`)
};

const pl_about_bio_intro_suffix = /** @type {(inputs: About_Bio_Intro_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lat budowania prawdziwych produktów, a nie tylko projektów pobocznych.`)
};

/**
* | output |
* | --- |
* | "years building real products, not just side projects." |
*
* @param {About_Bio_Intro_SuffixInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_bio_intro_suffix = /** @type {((inputs?: About_Bio_Intro_SuffixInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Bio_Intro_SuffixInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_bio_intro_suffix(inputs)
	if (locale === "bn") return bn_about_bio_intro_suffix(inputs)
	if (locale === "de") return de_about_bio_intro_suffix(inputs)
	if (locale === "es") return es_about_bio_intro_suffix(inputs)
	if (locale === "fr") return fr_about_bio_intro_suffix(inputs)
	if (locale === "pt") return pt_about_bio_intro_suffix(inputs)
	if (locale === "zh") return zh_about_bio_intro_suffix(inputs)
	if (locale === "tr") return tr_about_bio_intro_suffix(inputs)
	if (locale === "ru") return ru_about_bio_intro_suffix(inputs)
	if (locale === "pl") return pl_about_bio_intro_suffix(inputs)
	return en_about_bio_intro_suffix(inputs)
});